import { createTheme } from "@mui/material";
import { createBreakpoints } from "@mui/system";
import { rootTheme } from "../../utils/theme";
const breakpoints = createBreakpoints({});

export const whithdrawTheme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 14,
          marginBottom: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          borderRadius: 8,
          fontWeight: 700,
          color: "#F8FAFF",
        },
        notchedOutline: {
          display: 'none'
        }
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 700,
          color: "#F8FAFF",
          width: '100%',
          fontFamily: 'Manrope',
          outline: 'none',
          '&:hover': {
            border: '2px solid var(--03-action-blue, #0088F5)'
          },
        },

        outlined: 'none',

      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
          marginRight: 4,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "#F8F8F8",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 3,
          marginBottom: 3,
          color: "#0088F5",
          backgroundColor: "transparent",
          borderTopColor: "#0088F5",
          borderColor: "#0088F5",
          "&:before": {
            borderTopColor: "#0088F5"
          },
          "&:after": {
            borderTopColor: "#0088F5"
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#003B6A',
          padding: 20
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          height: "100%",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
          fontSize: 14,
          marginTop: 10,
          [breakpoints.up("md")]: {
            fontSize: 18,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: "inherit",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: 8,
          backgroundColor: "rgba(4, 25, 57, 0.6)",
        },
        bar1Determinate: {
          backgroundColor: "#0088F5",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 16,
          fontWeight: 700,
          color: "#F8FAFF",
        },
        secondary: {
          fontSize: 12,
          fontWeight: 400,
          color: "#F8FAFF",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        container: {
          marginLeft: 5,
          marginRight: 5,
          listStyle: 'none'
        },
        root: {
          cursor: "pointer",
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          color: "#F8FAFF",
          borderRadius: 8,
          minHeight: 75,
          marginTop: 10,
          "&.Mui-disabled": {
            color: "#D4D4D8",
            background: "rgba(0, 136, 245, 0.15)",
            opacity: 0.4,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#000",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
          width: "20px",
          height: "20px",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#0088F5',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline #0088F5'
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: 'transparent',
          boxShadow: 'none'
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          background: 'var(--07-offblue, rgba(0, 136, 245, 0.15))',
          '&:hover': {
            border: '2px solid var(--03-action-blue, #0088F5)'
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
          fontFamily: 'Manrope',          
        },
  
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          backgroundColor: '#27567c',
          color: '#FFFFFF',
          "&:active": {
            backgroundColor: '#27567c',
            color: '#27567c',
            outline: 'none',
            border: 'unset'
          },
        }
      }
    }
  },
});

export const styles = {
  form: {
    width: "100%",
  },
  navIconButton: {
    color: "rgba(0, 136, 245, 0.15)",
    marginLeft: 5,
  },
  navIconButtonActive: {
    color: "#0088F5",
  },
  selected: {
    backgroundColor: "rgba(4, 25, 57, 0.6)",
    color: "#0088F5",
  },
  bankListTransferItem: {
    borderRadius: "12px",
    marginBottom: 1.5,
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 1.25,
    paddingBottom: 1.25,
    alignItems: "flex-start",
    border: "1px solid #0E5B95",
    backgroundColor: "rgba(0, 136, 245, 0.15)",
    "&:hover": {
      // backgroundColor: "rgba(0, 136, 245, 0.2)",
    },
  },
  bankListTransferItemSelected: {
    // backgroundColor: "#0091FF",
    boxShadow: "0 0 0 2px rgba(0, 136, 245, 0.4)",
    // "&:hover": {
    //   backgroundColor: "#0091FF",
    // },
  },
  bankListVerifiedBadge: {
    marginLeft: 1,
    marginTop: 0.5,
    paddingLeft: 1.8,
    paddingRight: 1.8,
    paddingTop: 0.8,
    paddingBottom: 0.8,
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 400,
    color: "#0ECF72",
    backgroundColor: "rgba(11, 195, 116, 0.15)",
    whiteSpace: "nowrap",
  },
  bankListSelectedDivider: {
    marginTop: 1.2,
    marginBottom: 1.2,
    borderColor: "rgba(248, 250, 255, 0.35)",
  },
  bankListSelectedText: {
    fontSize: 13,
    fontWeight: 400,
    color: "#F8FAFF",
  },
  continueTooltip: {
    bgcolor: "#000000",
    fontSize: 14,
    paddingLeft: 3,
    paddingRight: 3,
    paddingTop: 1,
    paddingBottom: 1,
  },
  continueTooltipArrow: {
    color: "#000000",
  },
  outlineInput: {
    fontSize: 16,
    width: '100%',
  },
  loader: {
    width: 20,
    height: 20,
    marginLeft: 10
  },
  phone: {
    padding: '18px 10px',
    backgroundColor: 'rgba(0, 136, 245, 0.15)',
    boxShadow: 'none',
    borderRadius: 10,
    outline: 'none',
    border: 'unset',
    color: '#F8FAFF'
  },
  marginTop: {
    marginTop: 5,
  }
};

export const withdrawStatusTheme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
    },
  },
  components: {
    MuiGrid: {
      styleOverrides: {
        item: {
          lineHeight: 3,
          color: "#D4D4D8",
          fontSize: 14,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          width: "100%",
          marginBottom: 20,
          marginTop: 0,
          color: "#0088F5",
          backgroundColor: "transparent",
          borderTopColor: "#0088F5",
          borderColor: "#0088F5",
          "&:before": {
            borderTopColor: "#0088F5"
          },
          "&:after": {
            borderTopColor: "#0088F5"
          },
        },
      },
    },
  },
});

export const succesTheme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
    },
  },
  components: {
    MuiGrid: {
      styleOverrides: {
        item: {
          fontSize: 14,
          marginTop: 20
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 3,
          marginBottom: 3,
          color: "#0088F5",
          backgroundColor: "transparent",
          borderTopColor: "#0088F5",
          borderColor: "#0088F5",
          "&:before": {
            borderTopColor: "#0088F5"
          },
          "&:after": {
            borderTopColor: "#0088F5"
          },
        },
      },
    },
  }
});
